<template>
  <sea-page class="mt-login" title="Login">
    <v-card flat max-width="500" class="mx-auto style-login">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-alert type="error" :value="loginError">
                Email o password errata.
              </v-alert>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" v-if="!loginError">
              <v-icon :color="colors.primarycolor" x-large >mdi-account-circle</v-icon>  
              <h3 class="login-text">LOGIN</h3>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <form name="form" role="form" @submit.prevent="login()">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="10" offset-md="1">
                <v-text-field
                  prepend-icon="mdi-account"
                  placeholder="Username"
                  v-model="username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="10" offset-md="1">
                <v-text-field
                  prepend-icon="mdi-lock"
                  placeholder="Password"
                  :type="pwdVisible ? 'text' : 'password'"
                  v-model="password"
                >
                  <template v-slot:append>
                    <v-icon
                      style="cursor: pointer"
                      @click="pwdVisible = !pwdVisible"
                      >{{ pwdVisible ? "mdi-eye-off" : "mdi-eye" }}</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" offset-md="3">
                <v-btn :color="colors.primarycolor" dark rounded type="submit">Login</v-btn>
                <div class="mt-3">
                  <router-link to="/account/reset/init"
                    >Password dimenticata?</router-link
                  >
                </div>
                <div class="mt-3">Versione {{ version }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </form>
    </v-card>
    <div class="d-flex justify-center">
      <img class="dim-icon" :src="img_logo" />
    </div>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VERSION } from "@/constants";
import mixin from "@/mixin";
import { img_logo } from '../../constants';

export default {
  name: "login",
  mixins: [mixin],
  mounted() {
    if (this.account) {
      this.doLogout();
    }
  },
  data() {
    return {
      version: VERSION,
      username: null,
      password: null,
      rememberMe: false,
      pwdVisible: false,
      img_logo,
    };
  },
  computed: {
    ...mapGetters({
      loginError: "account/authenticationError",
      account: "account/account",
    }),
  },
  methods: {
    ...mapActions({
      doLogin: "account/doLogin",
      doLogout: "account/doLogout",
    }),
    login() {
      this.doLogin({
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

div {
  text-align: center;
}
.style-login {
  background-color: #ffffff57;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 5px;
}
.login-text {
  color: $systemcolor;
}
.mt-login {
  margin-top: 70px;
}
.dim-icon {
  margin-top: 10px;
  width: 200px;
}
</style>
